module.exports = __webpack_public_path__ + "static/media/52678040_2453005794774597_6641276095507202048_o.48b5ee07.jpg";